import { MinusIcon, PlusIcon } from "src/assets/Icons";
import { NumberControlType } from "src/components/NumberControl/NumberControl";
import dayjs from "dayjs";

type SearchFormInputs = {
  location?: {
    label: string;
    value: string;
    subLabel: string;
    type: "hotels" | "cities";
  };
  checkin?: dayjs.Dayjs;
  checkout?: dayjs.Dayjs;
  rooms: {
    adults: number;
    children: number;
    childrenAges: number[];
  }[];
  guestNationality?: string;
};

const INITIAL_SEARCH_FORM_VALUES = {
  location: undefined,
  rooms: [
    {
      adults: 1,
      children: 0,
      childrenAges: [],
    },
  ],
  checkin: undefined,
  checkout: undefined,
  guestNationality: undefined,
} satisfies SearchFormInputs;

const INPUT_CHIP_PROPS: NumberControlType = {
  min: 0,
  max: 10,
  plusAction: <PlusIcon />,
  minusAction: <MinusIcon />,
  classNames: {
    actions: ["disabled:text-font-disabled", "disabled:text-font-disabled"],
    display: "font-senibold",
  },
};




export { INITIAL_SEARCH_FORM_VALUES, INPUT_CHIP_PROPS };

type RoomGuestRequest = {
  adults: number;
  children: number;
  childrenAges: number[] | null;
};

type HotelSearchRequestType = {
  cityCode: string | null;
  hotelCode: string | null;
  checkIn: string | undefined;
  checkOut: string | undefined;
  rooms: RoomGuestRequest[];
  guestNationality: string | null;
  offset: number;
};

export type { SearchFormInputs, RoomGuestRequest, HotelSearchRequestType };
